import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ShrinkSvg = function ShrinkSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.31 8.75 6.72-6.72L21.97.968l-6.72 6.72v-6.19h-1.5v8.75h8.75v-1.5zM1.5 13.75h8.75v8.75h-1.5v-6.19l-6.72 6.72-1.06-1.061 6.72-6.72H1.5zM8.75 7.688V1.5h1.5v8.75H1.5v-1.5h6.19L.97 2.03 2.03.97zM13.75 13.75h8.75v1.5h-6.19l6.72 6.719-1.06 1.06-6.72-6.72v6.19h-1.5z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var Shrink = function Shrink(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ShrinkSvg
  }));
};